module.exports = __webpack_public_path__ + "static/media/gardensLogoType.400adfd1.svg";